"use strict";
module.exports = ['$locationProvider', function ($locationProvider) {
    $locationProvider.html5Mode({
        enabled: false,
        requireBase: false,
        rewriteLinks: false
    });
}];


//////////////////
// WEBPACK FOOTER
// ./src/gateway/core/configs/LocationProvider.js
// module id = 194
// module chunks = 2